import moment from "moment";

export default function(time, format) {
    if (typeof format !== 'string') {
        format = "MMMM Do YYYY, HH:mm:ss";
    }
    return moment(time).format(format);
}